<template>
  <div class="greetings"   >
    <div class="header__top">
      <button
          v-if="showExit"
          @click="closeChat"
          @keyup.enter="closeChat"
          @keyup.space="closeChat"
          :aria-label="$gettext('Cerrar chat')" 
          class="action-icon close" 
          tabindex="0">
        </button>
      <div class="header__greetings">
        <p v-if="isUserLogged" tabindex="0" >Hej <br><span>{{ name }}!</span></p>
        <p v-else class="bold__greeting hej__greeting" tabindex="0" v-translate v-html="this.$store.state.greetingText" :style="this.$store.state.greetingText == 'Hej!' ? '' : 'font-size: 16px'"></p>
        <!-- <span v-translate>{{ message }}</span> -->
      </div>
    </div>


  </div>
</template>

<script>
export default {
  props: ['isUserLogged', 'name', 'message', 'showExit'],
  methods: {
      closeChat() {
        this.$store.commit('setGreetingText', "Hej!");
        this.$emit('closeChat');
      }
    }
}
</script>